import React from 'react'
import { Formik } from 'formik'
import { useSelector } from 'react-redux'
import { InviteWorkersViaLinkSchema } from './InviteWorkersViaLinkForm.validator'
import tw from 'twin.macro'
import { getMarkets } from 'src/selectors/market'
import { getPartner } from 'src/selectors/user'
import { getOnboardingTemplates } from 'src/selectors/onboarding'
import { GSIcon } from '../../../shared/GSIcon'
import { BasicModalHeader, BasicModalDescription } from 'src/components/shared/modal'
import { InviteWorkersViaLinkFormContent } from './InviteWorkersViaLinkFormContent'
import { Divider } from '@mui/material'

export const InviteWorkersViaLinkForm = ({ onClose }: { onClose: () => void }) => {
  const markets = useSelector(getMarkets)
  const onboardingTemplates = useSelector(getOnboardingTemplates)
  const partner = useSelector(getPartner)

  return (
    <div css={tw`max-w-[528px] min-w-0`} data-testid="contractors-onboarding-invite-link-modal">
      <BasicModalHeader
        title="Invite contractor"
        onClose={onClose}
        closeButtonDataTestId="contractors-onboarding-invite-link-modal-close-btn"
      />
      <BasicModalDescription
        title="Invite via link"
        icon={<GSIcon iconName="gs_paper_plane_top_right" />}
        description="Select the market and onboarding flow — the link will be generated automatically and can be shared directly with the contractor."
      />
      <Divider css={tw`mt-4 mx-4 border-[#EDEDED] `} />
      <Formik
        initialValues={{
          partnerMarketId: markets?.length === 1 ? markets[0].id : undefined,
          collectDataTemplateId:
            onboardingTemplates?.length === 1 ? onboardingTemplates[0].id : undefined,
        }}
        onSubmit={() => {}}
        validationSchema={InviteWorkersViaLinkSchema}
      >
        <InviteWorkersViaLinkFormContent
          partner={partner}
          onboardingTemplates={onboardingTemplates}
          markets={markets}
        />
      </Formik>
    </div>
  )
}
